import React from 'react';
import './Review.css';

const Review = () => {
  const reviews = [
    { id: 1, name: "John D.", content: "Kyokushin Karate has transformed my life. The instructors are top-notch!", rating: 5 },
    { id: 2, name: "Sarah M.", content: "Great community and challenging workouts. Highly recommend!", rating: 4 },
    { id: 3, name: "Mike L.", content: "My kids love the children's classes. It's helped them build confidence.", rating: 5 },
  ];

  return (
    <section id="review" className="review-section">
      <h2>Student Reviews</h2>
      <div className="review-list">
        {reviews.map((review) => (
          <div key={review.id} className="review-item">
            <h3>{review.name}</h3>
            <p>{review.content}</p>
            <div className="rating">
              {"★".repeat(review.rating)}
              {"☆".repeat(5 - review.rating)}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Review;
